module.exports = __webpack_public_path__ + "img/five2Blue.b3aeaee7.jpg";